import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function ConsentModal() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem('cg-consent');
    if (!accepted) {
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cg-consent', 'true');
    setShow(false);
  };

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-[100] flex items-center justify-center p-4"
          style={{ backgroundColor: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(8px)' }}
          data-testid="consent-modal-overlay"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            transition={{ duration: 0.4, ease: 'easeOut' }}
            className="relative w-full max-w-xl rounded-2xl px-6 py-5 sm:px-8 sm:py-6"
            style={{
              backgroundColor: 'var(--color-card)',
              border: '1px solid var(--color-border)',
              boxShadow: '0 25px 80px rgba(0,0,0,0.3)',
            }}
            data-testid="consent-modal"
          >
            <h2
              className="text-2xl font-semibold mb-3 text-center"
              style={{ fontFamily: 'Cormorant Garamond, serif', color: 'var(--color-accent)' }}
            >
              Informations
            </h2>

            <div className="text-xs sm:text-[13px] leading-relaxed space-y-2" style={{ fontFamily: 'Outfit, sans-serif', color: 'var(--color-muted-fg)' }}>
              <p>
                Concept Gourmet Traiteur collecte et traite vos renseignements personnels afin de vous offrir une expérience plus personnalisée tout en assurant la sécurité de ses sites et de ses applications. Si vous souhaitez obtenir plus d'informations, vous pouvez vous rendre sur notre{' '}
                <a
                  href="https://privacy.ricardocuisine.com/fr/policy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline font-medium hover:text-[var(--color-primary)] transition-colors"
                  style={{ color: 'var(--color-fg)' }}
                  data-testid="consent-privacy-link"
                >
                  politique de confidentialité
                </a>.
              </p>

              <p>
                Avec votre accord, nous utilisons des cookies ou des technologies similaires pour stocker, consulter et traiter des données personnelles. Vous pouvez retirer votre consentement à tout moment via notre politique de confidentialité, sous l'onglet Termes et conditions.
              </p>

              <p className="font-medium" style={{ color: 'var(--color-fg)' }}>Concept Gourmet Traiteur utilisent les données suivantes :</p>

              <ul className="space-y-0.5 text-xs sm:text-[13px]">
                <li>· &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Compte abonné avec collecte de données;</li>
                <li>· &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Conservation et accès aux informations de géolocalisation pour réaliser des études marketing;</li>
                <li>· &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Données de géolocalisation précises et identification par analyse de l'appareil;</li>
                <li>· &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Publicités et contenu personnalisés;</li>
                <li>· &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Stocker et/ou accéder à des informations sur un appareil;</li>
                <li>· &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Transactions et enregistrement des modes de paiement.</li>
              </ul>
            </div>

            <div className="flex justify-center mt-4">
              <button
                onClick={handleAccept}
                data-testid="consent-accept-btn"
                className="px-10 py-2.5 rounded-full text-white font-semibold text-sm transition-all duration-300 hover:scale-105"
                style={{
                  background: 'linear-gradient(135deg, #F78A7D, #E8665A)',
                  boxShadow: '0 4px 20px rgba(247,138,125,0.35)',
                }}
              >
                J'accepte
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
